import { styled } from "styled-components";
import Card from "@joinTrilo/ui/atoms/Card";
import { border, colors, typography } from "@joinTrilo/ui/tokens";

export const StyledTippingModule = styled(Card)`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;

    padding: 1.6rem;
    width: 100%;
`;

export const StyledTipRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
`;

export const StyledTipWrapper = styled.div<{
    isActive: boolean;
    isLoading: boolean;
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;

    height: 4.8rem;

    border-radius: ${border.radius.lg};
    border: 0.1rem solid
        ${({ isActive }) =>
        isActive ? colors.darkTurquoise : colors.darkSilver};
    background: ${({ isActive, isLoading }) =>
        isLoading ? colors.lightSilver : isActive ? colors.darkTurquoise : colors.white};

    color: ${({ isActive, isLoading }) => (isLoading ? colors.deepGrey : isActive ? colors.white : colors.deepGrey)};
    font: ${typography.fonts.subHeadingSmall};

    cursor: ${({ isLoading }) => isLoading ? "wait" : "pointer"};
`;
